import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { Partecipant, PartecipantType, Project, company, Consultant, Company, Employee } from 'toolbandi-ui-lib';
import { SharedDataService, CrudService, MessageService, Search, Page } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-partecipant-edit',
	templateUrl: './partecipant-edit.component.html',
	styleUrls: ['./partecipant-edit.component.scss']
})
export class PartecipantEditComponent implements OnInit, OnDestroy {

	loading: boolean = true;
	partecipant: Partecipant;
	title: string;

	@Input()
	projectid: number;
	project: Project;


	partecipantType = Object.keys(PartecipantType).map(p => PartecipantType[p]);

	search: {
		company: Search,
		consultant: Search
	};

	@Output()
	onPartecipantAdd = new EventEmitter();

	constructor(
		private sharedDataService: SharedDataService,
		private partecipantService: CrudService<Partecipant>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private activeModal: NgbActiveModal,
		private projectService: CrudService<Project>,
		private companyService: CrudService<Company>,
		private consultantService: CrudService<Consultant>
	) {

		this.search = {
			company: new Search('company'),
			consultant: new Search('consultant')
		};
	}

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	ngOnInit(): void {
		this.loadProject();
	}

	loadProject(): void {
		this.projectService.getEntity(Project, 'project', this.projectid).subscribe((data: Project) => {
			this.project = data;
		});
	}

	load(id: number): void {
		if (id) {
			this.loading = true;
			this.partecipantService.getEntity(Partecipant, 'partecipant', id).subscribe(partecipant => {
				this.partecipant = partecipant;
				this.title = 'partecipant-edit';
				this.initItem();
			}, ({ error }) => {
				this.messageService.sendError(error, this.translateService.instant('labels.partecipant'));
				this.partecipant = undefined;
				this.loading = false;
			});

		} else {
			this.partecipant = new Partecipant();
			this.title = 'partecipant-create';
			this.partecipant.projectid = this.projectid;
			this.loading = false;
		}

	}

	initItem(): void {
		if (this.partecipant.isCompany) {
			this.companyService.getEntity(Company, 'company', this.partecipant.eid).subscribe((res: Company) => {
				this.partecipant.entityobj = res;
				this.loading = false;
			});
		} else {
			this.consultantService.getEntity(Consultant, 'consultant', this.partecipant.eid).subscribe((res: Consultant) => {
				this.partecipant.entityobj = res;
				this.loading = false;
			});
		}
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	submit(): void {

		this.loading = true;

		this.partecipant.eid = this.partecipant.entityobj.id;
		const entityobj = this.partecipant.entityobj;
		this.partecipant.entityobj = null;

		if (!this.partecipant.id) {
			this.partecipantService.createEntity(Partecipant, 'partecipant', this.partecipant).subscribe(response => {
				this.partecipant = response;
				this.partecipant.entityobj = entityobj;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.partecipant-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close(this.partecipant);
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		} else {
			this.partecipantService.saveEntity(Partecipant, 'partecipant', this.partecipant).subscribe(response => {
				this.partecipant = response;
				this.messageService.sendSuccess(
					this.translateService.instant('labels.partecipant-save-success'),
					this.translateService.instant('labels.success')
				);
				this.activeModal.close();
			}, ({ error }) => {
				this.messageService.sendError(
					error.msg ? error.msg : error,
					this.translateService.instant('labels.event-save-error')
				);
			});
		}
	}

	resetEntity(): void {
		this.partecipant.eid = undefined;
		this.partecipant.entityobj = undefined;
	}

}
